import React, {Component} from 'react';
import { Col, Row } from 'reactstrap';

class LiveChatComponent extends Component {

    onChangeValue = (event) => {
        let text  = event.target.value;
        this.props.onChangeValue(text);
    }

    render() {
        return (
            <>
                <Row className="form-group">
                    <Col md={2} className="col-form-label">
                        <label htmlFor="live_chat">Live Chat</label>
                    </Col>
                    <Col md={10}>
                        <textarea onChange={this.onChangeValue} className="form-control" placeholder="Live Chat" cols={40} rows={8}>
                            {this.props.liveChat}
                        </textarea>
                    </Col>
                </Row>
            </>
        );
    }
}

export default LiveChatComponent;